import { render } from "./VectorGlasses.vue?vue&type=template&id=0b1e8b8a"
import script from "./VectorGlasses.vue?vue&type=script&lang=js"
export * from "./VectorGlasses.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.16_vue@3.5.16_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__